import React from 'react';
import {Flex } from '/app/src/component';
import {Validation} from '/app/src/lib'

import PaymentInfoInput from '../PaymentInfoInput'
import BackBtn from '../BackBtn'
import NextBtn from '../NextBtn'
import DotProgress from '../DotProgress'

const formStyle = {
    width: '257px',
    height: '33px',
    borderRadius: '10px',
    backgroundColor: '#f0f0f0',
    border: 'solid 1p #707070',
    padding: '0px 15px 0px 15px',
    fontFamily: 'Roboto',
    fontSize: '24px',
    fontWeight: '300',
    fontStyle: 'normal',
    fontStretch: 'normal'
}

const rowStyle = {
    margin: '15px 15px 0px 15px',
    hAlignContent: 'left',
}
const inputStyle = {
    maxWidth: '280px',
    margin: '0px 25px'
}
const headerStyle = {
    fontSize: '28px',
    margin: '20px 0px 5px 0px',
    color: 'DarkGray',
    fontWeight: '300'
}
const backBtnStyle = {
    hAlignContent: 'left',
    width: '50%'
}
const nextBtnStyle = {
    hAlignContent: 'right',
    width: '50%',
    margin: '0px 25px 10px 0px'
}
const navigationStyle = {
    vAlignContent: 'bottom'
}

const inputContainer = {
    width: '640px',
    margin: '0 auto'
}

const labelStyle = {
    fontSize: '18px',
    paddingLeft: '5px',
    marginBottom: '3px'
}

const dotProgressStyle = {
    paddingBottom: '10px',
    hAlignContent: 'center'
}

class PaymentInfo extends React.Component {
    constructor() {
        super()
        this._continueBtnClick = this._continueBtnClick.bind(this)
        const inputs = ['companyName', 'address', 'city', 'email', 'orgNbr', 'postalCode']
        this.validator = new Validation(inputs)
        this.state = {
            hasValidInput: true
        }
    }

    _continueBtnClick() {
        const {nextButtonClick, companyName, email, orgNbr, address, city, postalCode} = this.props

        //Have to assume true, else it won't re-render to display new errors.
        this.setState({hasValidInput: true})
        this.validator.validate(['notEmpty'], 'companyName', companyName)
        this.validator.validate(['notEmpty', 'email'], 'email', email)
        this.validator.validate(['notEmpty'], 'orgNbr', orgNbr)
        this.validator.validate(['notEmpty'], 'address', address)
        this.validator.validate(['notEmpty'], 'city', city)
        this.validator.validate(['notEmpty', 'postalCode'], 'postalCode', postalCode)
        if (this.validator.allValid()) {
            nextButtonClick()
        } else {
            this.setState({hasValidInput: false})
        }
    }


    render() {
        const {backButtonClick, onChange, companyName, email, orgNbr,
            address, city, postalCode} = this.props
        return <Flex grow column>
            <Flex {...headerStyle} center>
                Faktureringsuppgifter
            </Flex>
            <Flex {...inputContainer} column>
                <Flex {...rowStyle}>
                    <Flex {...inputStyle}>
                        <PaymentInfoInput
                            label='Företagsnamn'
                            placeholder='Företagsnamn'
                            value={companyName}
                            hasValidInput={this.state.hasValidInput}
                            errorMsg={this.validator.errorMsg('companyName')}
                            onChange={(e) => onChange('companyName', e.target.value)}/>
                    </Flex>
                    <Flex {...inputStyle}>
                        <PaymentInfoInput
                            label='Adress'
                            placeholder='Adress'
                            value={address}
                            hasValidInput={this.state.hasValidInput}
                            errorMsg={this.validator.errorMsg('address')}
                            onChange={(e) => onChange('address', e.target.value)}/>
                    </Flex>
                </Flex>
                <Flex {...rowStyle}>
                    <Flex {...inputStyle}>
                        <PaymentInfoInput
                            label='E-post'
                            placeholder='E-post'
                            value={email}
                            hasValidInput={this.state.hasValidInput}
                            errorMsg={this.validator.errorMsg('email')}
                            onChange={(e) => onChange('email', e.target.value)}/>
                    </Flex>
                    <Flex {...inputStyle}>
                        <PaymentInfoInput
                            label='Stad'
                            placeholder='Stad'
                            value={city}
                            hasValidInput={this.state.hasValidInput}
                            errorMsg={this.validator.errorMsg('city')}
                            onChange={(e) => onChange('city', e.target.value)}/>
                    </Flex>
                </Flex>
                <Flex {...rowStyle}>
                    <Flex {...inputStyle}>
                        <PaymentInfoInput
                            label='Organisationsnummer'
                            placeholder='Organisationsnummer'
                            value={orgNbr}
                            hasValidInput={this.state.hasValidInput}
                            errorMsg={this.validator.errorMsg('orgNbr')}
                            onChange={(e) => onChange('orgNbr', e.target.value)}/>
                    </Flex>
                    <Flex {...inputStyle}>
                        <PaymentInfoInput
                            label='Postnummer'
                            placeholder='Postnummer'
                            value={postalCode}
                            hasValidInput={this.state.hasValidInput}
                            errorMsg={this.validator.errorMsg('postalCode')}
                            onChange={(e) => onChange('postalCode', e.target.value)}/>
                    </Flex>
                </Flex>
                <Flex {...rowStyle}>
                    <Flex {...inputStyle} column>
                        <Flex {...labelStyle}>{'Land'}</Flex>
                        <select name="country" style={formStyle} autoComplete='address-level1'>
                            <option value="sweden">Sverige</option>
                        </select>
                    </Flex>
                </Flex>
            </Flex>
            <Flex grow>
                <Flex {...backBtnStyle} {...navigationStyle}>
                    <BackBtn onClick={backButtonClick} text='Tillbaka'/>
                </Flex>
                <Flex {...nextBtnStyle} {...navigationStyle}>
                    <NextBtn
                        onClick={this._continueBtnClick}
                        text='Fortsätt'
                        src='/images/ArrowDirection_Right_S.svg'
                        iconPos='right'
                        fineText='Till översikt'/>
                </Flex>
            </Flex>
            <Flex {...dotProgressStyle}>
                <DotProgress currentPage={1}/>
            </Flex>
        </Flex>
    }
}

export default PaymentInfo;



// WEBPACK FOOTER //
// ./src/component/Modal/PaymentModal/Pages/PaymentInfoPage.js